
import React from 'react';

export const BlogStyleSheet: React.FC = () => {
  return (
    <style>{`
      .blog-content {
        text-align: left;
      }
      .blog-content p {
        margin-bottom: 1.25rem;
        line-height: 1.7;
      }
      .blog-content h1, .blog-content h2, .blog-content h3, 
      .blog-content h4, .blog-content h5, .blog-content h6 {
        margin-top: 1.5rem;
        margin-bottom: 1rem;
        font-weight: 600;
        line-height: 1.25;
        text-align: left;
      }
      .blog-content ul, .blog-content ol {
        margin-bottom: 1.25rem;
        padding-left: 1.5rem;
      }
      .blog-content li {
        margin-bottom: 0.5rem;
      }
      .blog-content blockquote {
        border-left: 4px solid #e2e8f0;
        padding-left: 1rem;
        margin-left: 0;
        margin-right: 0;
        font-style: italic;
        margin-bottom: 1.25rem;
      }
      .blog-content pre {
        background-color: #f7fafc;
        border-radius: 0.375rem;
        padding: 1rem;
        overflow-x: auto;
        margin-bottom: 1.25rem;
      }
      .blog-content hr {
        margin-top: 2rem;
        margin-bottom: 2rem;
        border: 0;
        border-top: 1px solid #e2e8f0;
      }
    `}</style>
  );
};
